

<div class="mat-content">
  <mat-panel-title>
    {{ itemLabel }}
  </mat-panel-title>
</div>
<button [matMenuTriggerFor]="actionMenu"
        #trigger="matMenuTrigger"
        [ngClass]="{'open': trigger.menuOpen}"
        class="btn dropdown-button d-flex justify-content-between align-items-center w-100">
  <span class="d-flex align-items-center">
    <ng-container *ngIf="!itemLabel">
      <span class="icon-left">
        <span class="locked" *ngIf="!currentItem.inherited && currentItem.type === templateType.FORM || currentItem.type === templateType.SEARCH">
          <img [src]="currentItem.type === templateType.FORM ? 'assets/img/search/search_form.svg' : 'assets/img/search/search_with_values.svg'"
               [alt]="currentItem.type === templateType.FORM ? 'Only form' : 'Form with values'">
        </span>
        <span class="locked" *ngIf="currentItem.inherited">
          <i class="far fa-lock" aria-hidden="true"></i>
          <span class="sr-only">Owned by admin</span>
        </span>
      </span>
      <span class="action-label">{{currentItem.label}}</span>
    </ng-container>

    <span class="action-label" *ngIf="itemLabel">-Select-</span>
  </span>
  <i class="fa"
     [ngClass]="{'fa-angle-up': trigger.menuOpen, 'fa-angle-down': !trigger.menuOpen}"
     aria-hidden="true"></i>
</button>
<mat-menu #actionMenu="matMenu" class="my-search-list">
  <button class="btn-item btn-item-create" (click)="emitDefaultAction()" mat-menu-item>
    <span class="action-label text-black"><span class="plus">+</span> {{defaultActionName}}</span>
  </button>
  <button *ngFor="let item of itemList"(click)="openItem(item)" mat-menu-item
          class="btn-item"
          [ngClass]="{'btn-item__selected': item.templateCode === currentItem?.templateCode}">
    <div class="btn-item-content d-flex">
      <div class="icon-left">
        <span class="locked" *ngIf="!item.inherited && item.type === templateType.FORM || item.type === templateType.SEARCH">
          <img
            [src]="item.type === templateType.FORM ? 'assets/img/search/search_form.svg' : 'assets/img/search/search_with_values.svg'"
            [alt]="item.type === templateType.FORM ? 'Only form' : 'Form with values'">
        </span>
        <span class="locked" *ngIf="item.inherited">
          <i class="far fa-lock" aria-hidden="true"></i>
          <span class="sr-only">Owned by admin</span>
        </span>
      </div>
      <div>
        <p class="action-label text-black">{{item.label}}</p>
        <p class="modified-date text-black">Date modified: <span class="date">{{item.modifiedDate | date: 'MM/dd/yyyy'}}</span></p>
      </div>
    </div>
  </button>
</mat-menu>
